import { Stack, ThemeProvider, createTheme } from "@mui/material"
import { useEffect, useLayoutEffect, useRef, useState } from "react"
import Overview from "./Overview"
import Details from "./Details"
import Quote from "./Quote"
import About from "./About"
import Bottom from "./Bottom"
import NextSteps from "./NextSteps"
import Results from "./Results"
import Partners from "./Partners"
import TopBar from "./TopBar"

function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#e6eef6",
      },
    },
    typography: {
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
      allVariants: {
        color: "#e6eef6",
      },
    },
  })

  const windowRef = useRef<HTMLDivElement | null>(null)
  const [width, setWidth] = useState(0)
  useLayoutEffect(() => {
    setWidth(windowRef.current?.getBoundingClientRect().width ?? 0)
  }, [])
  useEffect(() => {
    const handler = () =>
      setWidth(windowRef.current?.getBoundingClientRect().width ?? 0)
    window.addEventListener("resize", handler, true)
    return () => {
      window.removeEventListener("resize", handler, true)
    }
  }, [])

  const phone = width < 900

  return (
    <ThemeProvider theme={theme}>
      <Stack
        ref={windowRef}
        textAlign="center"
        width="100vw"
        alignItems="center"
        sx={{ background: "#08305A" }}
      >
        <TopBar phone={phone} />

        <Stack
          ref={windowRef}
          textAlign="center"
          width="100%"
          maxWidth="1100px"
          alignItems="center"
        >
          <Overview phone={phone} />
          <Quote />
          <Details phone={phone} />
          <NextSteps phone={phone} />
          <Results phone={phone} />
          <About phone={phone} />
          <Partners phone={phone} />
          <Bottom />
        </Stack>
      </Stack>
    </ThemeProvider>
  )
}

export default App
